import React from 'react'
import TableHeader from '../../../components/table/TableHeader'
import Text from '../../../components/text/Text'
import TableLayout from '../../../components/table/TableLayout'
import TableItem from '../../../components/table/TableItem'
import Span from '../../../components/text/Span'
import useNavigation from '../../../hooks/useNavigation'
import {useTime} from '../../../utils/time'
import {IWithdraw} from '../../../apis/withdraw/withdraw'
import {useString} from '../../../utils/string'

interface IProps {
    className?: string
    data?: IWithdraw[]
    paymentFailed?: boolean
}

const WithdrawTable: React.FC<IProps> = ({className, data, paymentFailed}) => {
    const {goWithdrawDetail} = useNavigation()
    const {convertUtc0ToUtc9} = useTime()

    const {shortCutString} = useString()

    const renderStatusTag = (status, sign) => {
        if (status === 'created' && sign) {
            return (
                <Text className={'bg-[#b9c5ff] text-[#5e60da] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                    processing
                </Text>
            )
        }

        switch (status) {
            case 'confirmed':
                return (
                    <Text
                        className={'bg-tag_green_light text-font_green text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                        {status}
                    </Text>
                )
            case 'canceled':
                return (
                    <Text className={'bg-[#f0eba3] text-[#d57b1a] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                        {status}
                    </Text>
                )
            case 'failed':
                return (
                    <Text className={'bg-tag_red_light text-font_red text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                        {status}
                    </Text>
                )
            case 'created':
                return (
                    <Text className={'bg-[#d9f4f5] text-[#7eb0f9] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                        {status}
                    </Text>
                )
            case 'pending':
                return (
                    <Text className={'bg-[#f2d2f8] text-[#d56ae5] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                        {status}
                    </Text>
                )
            case 'processing':
                return (
                    <Text className={'bg-[#b9c5ff] text-[#5e60da] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                        {status}
                    </Text>
                )
            default:
                return (
                    <Text className={'bg-bg_gray01 text-font02 text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'}>
                        {status}
                    </Text>
                )
        }
    }

    return (
        <div className={className}>
            <TableHeader className={'grid-cols-5 md:grid-cols-4 sm:hidden'}>
                <Text>User ID</Text>
                <Text>Amount</Text>
                <Text>Network</Text>
                <Text>Status</Text>
                <Text className={'md:hidden'}>Update At</Text>
            </TableHeader>

            <TableLayout>
                {data?.map(item => (
                    <TableItem
                        className={'grid-cols-5 md:grid-cols-4 sm:block sm:space-y-[10px] sm:!px-[20px]'}
                        onClick={() => {
                            goWithdrawDetail(item?.id, paymentFailed ? 'failed' : '')
                        }}>
                        <div>
                            <Span className={'hidden sm:inline'}>ID : </Span>
                            <Text className={'lg:hidden'}>{item?.user_id}</Text>
                            <Text className={'hidden lg:inline-block'}>{shortCutString(item?.user_id, 5)}</Text>
                        </div>
                        <div>
                            <Text>
                                <Span className={'hidden sm:inline'}>Amount : </Span>
                                <Span className={'text-ti2'}>{item?.amount}</Span>{' '}
                                <Span className={'md:text-body_comm md:text-font03'}>{item?.coin}</Span>
                            </Text>
                        </div>
                        <div>
                            <Span className={'hidden sm:inline'}>Chain : </Span>
                            <Text className={'sm:inline-block'}>{item?.blockchain}</Text>
                        </div>
                        <div>{renderStatusTag(item?.status, item?.approval_signature)}</div>
                        <div className={'md:col-span-4'}>
                            <Text className={'text-font03 md:text-right md:text-body3 md:relative'}>
                                {convertUtc0ToUtc9(Number(item?.updated_at) * 1000)}
                            </Text>
                        </div>
                    </TableItem>
                ))}
            </TableLayout>
        </div>
    )
}

export default WithdrawTable
